module.exports = __webpack_public_path__ + "img/sorry.40dba4e4.png";